<script>
  export let name
</script>

{#if name === "cube-o"}
  <svg
    aria-hidden="true"
    fill="none"
    id="cube-o"
    stroke-width="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...$$restProps}
  >
    <path
      d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
{:else if name === "currency-dollar-o"}
  <svg
    aria-hidden="true"
    fill="none"
    id="currency-dollar-o"
    stroke-width="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...$$restProps}
  >
    <path
      d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
{:else if name === "lock-closed"}
  <svg
    aria-hidden="true"
    fill="currentColor"
    id="lock-closed"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...$$restProps}
  >
    <path
      clip-rule="evenodd"
      d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z"
      fill-rule="evenodd"
    />
  </svg>
{:else if name === "lock-closed-o"}
  <svg
    aria-hidden="true"
    fill="none"
    id="lock-closed-o"
    stroke-width="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...$$restProps}
  >
    <path
      d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
{:else if name === "scale"}
  <svg
    aria-hidden="true"
    fill="currentColor"
    id="scale"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...$$restProps}
  >
    <path
      clip-rule="evenodd"
      d="M12 2.25a.75.75 0 01.75.75v.756a49.106 49.106 0 019.152 1 .75.75 0 01-.152 1.485h-1.918l2.474 10.124a.75.75 0 01-.375.84A6.723 6.723 0 0118.75 18a6.723 6.723 0 01-3.181-.795.75.75 0 01-.375-.84l2.474-10.124H12.75v13.28c1.293.076 2.534.343 3.697.776a.75.75 0 01-.262 1.453h-8.37a.75.75 0 01-.262-1.453c1.162-.433 2.404-.7 3.697-.775V6.24H6.332l2.474 10.124a.75.75 0 01-.375.84A6.723 6.723 0 015.25 18a6.723 6.723 0 01-3.181-.795.75.75 0 01-.375-.84L4.168 6.241H2.25a.75.75 0 01-.152-1.485 49.105 49.105 0 019.152-1V3a.75.75 0 01.75-.75zm4.878 13.543l1.872-7.662 1.872 7.662h-3.744zm-9.756 0L5.25 8.131l-1.872 7.662h3.744z"
      fill-rule="evenodd"
    />
  </svg>
{:else if name === "user"}
  <svg
    aria-hidden="true"
    fill="currentColor"
    id="user"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...$$restProps}
  >
    <path
      clip-rule="evenodd"
      d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
      fill-rule="evenodd"
    />
  </svg>
{/if}
